/**
 * GradientButton
 * Bottone con gradiente rosa identico alla PWA:
 *   linear-gradient(135deg, var(--rosa), var(--rosa-light))
 */

import { useMemo } from 'react'
import { TouchableOpacity, Text, View, StyleSheet } from 'react-native'
import { LinearGradient } from 'expo-linear-gradient'
import { fonts, radius } from '../lib/theme'
import { useThemeColors } from '../lib/useThemeColors'
import { hapticMedium } from '../lib/haptics'

const GRADIENT_START = { x: 0, y: 0 }
const GRADIENT_END   = { x: 1, y: 1 }

const SIZE = {
  sm: { paddingVertical: 8,  paddingHorizontal: 16, borderRadius: radius.md, fontSize: 13 },
  md: { paddingVertical: 12, paddingHorizontal: 24, borderRadius: radius.lg, fontSize: 15 },
  lg: { paddingVertical: 13, paddingHorizontal: 24, borderRadius: radius.lg, fontSize: 15 },
}

export default function GradientButton({ onPress, disabled, loading, size = 'md', style, textStyle, children, icon, iconPosition = 'right' }) {
  const tc = useThemeColors()
  const sz = SIZE[size] ?? SIZE.md
  const isDisabled = disabled || loading

  const gradientColors = [tc.rosa, tc.rosaLight]

  const styles = useMemo(() => StyleSheet.create({
    base:     { overflow: 'hidden' },
    gradient: { alignItems: 'center', justifyContent: 'center' },
    text:     { color: tc.brandText, fontFamily: fonts.condensedBold, letterSpacing: 0.5 },
    row:      { flexDirection: 'row', alignItems: 'center', gap: 6 },
  }), [tc])

  const handlePress = () => {
    hapticMedium()
    onPress?.()
  }

  const content = icon ? (
    <View style={styles.row}>
      {iconPosition === 'left' && icon}
      <Text style={[styles.text, { fontSize: sz.fontSize }, textStyle]}>{children}</Text>
      {iconPosition === 'right' && icon}
    </View>
  ) : (
    <Text style={[styles.text, { fontSize: sz.fontSize }, textStyle]}>{children}</Text>
  )

  if (isDisabled) {
    return (
      <TouchableOpacity
        style={[styles.base, { backgroundColor: tc.bgCard2, borderRadius: sz.borderRadius, paddingVertical: sz.paddingVertical, paddingHorizontal: sz.paddingHorizontal, alignItems: 'center' }, style]}
        disabled
        activeOpacity={1}
      >
        <Text style={[styles.text, { fontSize: sz.fontSize, color: tc.textDim }, textStyle]}>
          {loading ? '...' : children}
        </Text>
      </TouchableOpacity>
    )
  }

  return (
    <TouchableOpacity onPress={handlePress} style={[styles.base, style]} activeOpacity={0.85}>
      <LinearGradient
        colors={gradientColors}
        start={GRADIENT_START}
        end={GRADIENT_END}
        style={[styles.gradient, { borderRadius: sz.borderRadius, paddingVertical: sz.paddingVertical, paddingHorizontal: sz.paddingHorizontal }]}
      >
        {content}
      </LinearGradient>
    </TouchableOpacity>
  )
}